const imgFiles = [
  {name: "shirts1", ext: "webp"},
  {name: "shirts2", ext: "webp"},
  {name: "shirts3", ext: "webp"},
  {name: "shirts4", ext: "webp"},
  {name: "shirts5", ext: "webp"},
  {name: "shirts6", ext: "webp"},
  {name: "shirts7", ext: "webp"},
  {name: "shirts8", ext: "webp"},
  {name: "shirts9", ext: "webp"},
  {name: "shirts10", ext: "webp"},
  {name: "shirts11", ext: "webp"},
  {name: "shirts12", ext: "webp"},
  {name: "shirts13", ext: "webp"},
  {name: "shirts14", ext: "webp"},
  {name: "shirts15", ext: "webp"},
  {name: "shirts16", ext: "webp"},
  {name: "shirts17", ext: "webp"},
  {name: "shirts18", ext: "webp"},
  {name: "shirts19", ext: "webp"},
  {name: "shirts20", ext: "webp"},
];

export default imgFiles